import React, { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';
import './Agenda.css';
import Paper from '@material-ui/core/Paper';
import { ViewState } from '@devexpress/dx-react-scheduler';
import {
	Scheduler,
	DayView,
	Appointments,
	AppointmentTooltip,
	AppointmentForm,
	WeekView,
	MonthView,
	ViewSwitcher,
	Toolbar,
	DateNavigator,
	TodayButton,
} from '@devexpress/dx-react-scheduler-material-ui';
import {
	Grid,
	Divider,
	Menu,
	MenuItem,
	Button,
	CircularProgress,
	darken,
	fade,
	FormControlLabel,
	lighten,
	makeStyles,
	Radio,
	RadioGroup,
	TextField,
	Typography,
	withStyles,
	IconButton,
} from '@material-ui/core';
import { ColorLens, Person } from '@material-ui/icons';
import PhoneIcon from '@material-ui/icons/Phone';
import PersonIcon from '@material-ui/icons/Person';
import DraftsIcon from '@material-ui/icons/Drafts';
import CloseIcon from '@material-ui/icons/Close';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DeleteIcon from '@material-ui/icons/Delete';
import AccessTime from '@material-ui/icons/AccessTime';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import createTypography from '@material-ui/core/styles/createTypography';
import { useHistory } from 'react-router';
import classNames from 'clsx';
import {
	useTooltipContentStyles,
	useTooltipHeaderStyles,
} from '../../muiStyles/Agenda.mui';
import Modal from '../layout/modal/Modal';
import RescheduleMeeting from './rescheduleMeeting/RescheduleMeeting';
import ScheduleMeeting from './scheduleMeeting/ScheduleMeeting';

//Redux
import { connect } from 'react-redux';
import AddPeople from './addPeople/AddPeople';
import UpcomingAppointmentList from './upcomingAppointmentList/UpcomingAppointmentList';
import { upcommingAppointments } from '../../redux/appointments/actions';
import { getAgendaData } from '../../api/Agenda/agenda.api';
import JoinShortCode from './joinFromCode/JoinShortCode';
import { closeModal, openModal } from '../../redux/modals/action';

const Agenda = ({
	userType,
	upcommingAppointments,
	modal,
	openModal,
	closeModal,
}) => {
	const [schedulerData, setSchedulerData] = useState();
	const { firebase } = useContext(FirebaseContext);
	const [currentViewName, setCurrentViewName] = useState();
	const [toolTipData, setToolTipData] = useState();
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const [formData, setFormData] = useState({
		notes: '',
	});
	const [filterByDate, setFilterByDate] = useState('Month');
	const [rescheduleModal, setRescheduleModal] = useState(false);
	const [tooltipVisible, setTooltipVisible] = useState(false);
	const [scheduleModal, setScheduleModal] = useState(false);
	const [dateClicked, setDateClicked] = useState();
	const [appointmentMeta, setAppointmentMeta] = useState({
		target: null,
		data: {},
	});

	const { notes } = formData;
	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	useEffect(() => {
		getAgendaData(userType, (returned) => setSchedulerData(returned));
		upcommingAppointments();
	}, []);

	const onAppointmentMetaChange = ({ data, target }) => {
		setAppointmentMeta({ data, target });
	};

	const MonthViewTimeTableCell = ({ onDoubleClick, ...restProps }) => {
		return (
			<MonthView.TimeTableCell
				onClick={() => {
					openModal('scheduleMeeting');
					setDateClicked(restProps.startDate);
				}}
				{...restProps}
			/>
		);
	};

	const DayViewTimeTableCell = ({ onDoubleClick, ...restProps }) => {
		return (
			<DayView.TimeTableCell
				onClick={() => {
					openModal('scheduleMeeting');
					setDateClicked(restProps.startDate);
				}}
				{...restProps}
			/>
		);
	};

	const WeekViewTimeTableCell = ({ onDoubleClick, ...restProps }) => {
		return (
			<WeekView.TimeTableCell
				onClick={() => {
					openModal('scheduleMeeting');
					setDateClicked(restProps.startDate);
				}}
				{...restProps}
			/>
		);
	};

	const ExternalViewSwitcher = ({ currentViewName, onChange }) => (
		<RadioGroup
			aria-label='Views'
			style={{ flexDirection: 'row' }}
			name='views'
			value={currentViewName}
			onChange={onChange}
			className={styles.radioGroup}
		>
			<FormControlLabel
				value='Month'
				control={<Radio className={styles.radioBtn} />}
				label='Month'
				className={styles.radioLabel}
			/>
			<FormControlLabel
				value='Week'
				control={<Radio className={styles.radioBtn} />}
				label='Week'
				className={styles.radioLabel}
			/>
			<FormControlLabel
				value='Day'
				control={<Radio className={styles.radioBtn} />}
				label='Day'
				className={styles.radioLabel}
			/>
		</RadioGroup>
	);

	const currentViewNameChange = (e) => {
		console.log('current view name: ' + e.target.value);
		setCurrentViewName(e.target.value);
	};

	const currentDate = dayjs(new Date()).format('YYYY-MM-DDTHH:mm');

	const handleRescheduleBtnClick = () => {
		setTooltipVisible(false);
		setRescheduleModal(true);
	};

	const handleRescheduleModalClose = () => {
		setRescheduleModal(false);
	};

	const handleScheduleModalClose = () => {
		closeModal('scheduleModal');
	};

	const useStyles = makeStyles({
		radioGroup: {
			justifyContent: 'flex-end',
			marginBottom: '-50px',
		},
		radioBtn: {
			display: 'none',
		},
		radioLabel: {
			border: '1px solid #c7c7c7',
			padding: ' 2px 20px',
			marginTop: '30px',
			zIndex: '1',

			'&:hover': {
				backgroundColor: '#c7c7c7',
			},
		},
		dateNavigator: {
			backgroundColor: 'red',
		},
		tooltipPaper: {
			paddingBottom: '10px',
			position: 'relative',
		},
		tooltipIcon: {
			color: '#999999',
		},
		tooltipCloseBtn: {
			position: 'absolute',
			top: '8px',
			right: '0',
		},
		notesInput: {
			height: 100,
			width: '100%',
		},
		notesTextField: {
			width: '100%',
		},
	});

	const styles = useStyles();

	const Appointment = ({ children, style, data, ...restProps }) => (
		<Appointments.Appointment
			{...restProps}
			style={{
				...style,
				borderRadius: '5px',
			}}
			className='appointment'
			onClick={(e) => {
				setToolTipData(data);
				setTooltipVisible(true);
				onAppointmentMetaChange({
					target: document.getElementById('calendarPage'),
					data,
				});
				// console.log('setToolTipData: ', data);
				// setFormData({ notes: data?.notes ? data?.notes : '' });
			}}
		>
			{children}
		</Appointments.Appointment>
	);

	const TooltipHeader = ({ ...restProps }) => {
		const classes = useTooltipHeaderStyles();
		return (
			<AppointmentTooltip.Header
				{...restProps}
				appointmentData={toolTipData}
				classes={{
					head: classes.head,
				}}
			>
				<IconButton aria-label='delete' onClick={handleCancel}>
					<DeleteIcon />
				</IconButton>
				<Divider orientation='vertical' flexItem />
				<IconButton aria-label='close' onClick={handleClose}>
					<CloseIcon />
				</IconButton>
			</AppointmentTooltip.Header>
		);
	};

	const TooltipContent = ({ formatDate }) => {
		const classes = useTooltipContentStyles();
		let appointments = JSON.parse(JSON.stringify(toolTipData));
		appointments.title = appointments.title.replace('Meeting with ', '');
		return (
			<div className={classes.content}>
				<Grid
					container
					alignItems='flex-start'
					className={classes.titleContainer}
				>
					<Grid item xs={9}>
						<div
							className={classNames(
								classes.title,
								classes.dateAndTitle
							)}
						>
							{appointments.title}
						</div>
						<div
							className={classNames(
								classes.text,
								classes.dateAndTitle
							)}
						>
							{formatDate(appointments.startDate, {
								weekday: 'long',
								year: 'numeric',
								month: 'long',
								day: 'numeric',
							})}
						</div>
					</Grid>
					<Grid item xs={3}>
						<div className={classes.tag}>Virtual</div>
					</Grid>
				</Grid>
				<Grid
					container
					alignItems='center'
					className={classes.contentContainer}
				>
					<Grid item xs={12}>
						<AccessTime className={classes.icon} />
						<div className={classes.time}>
							{`${formatDate(appointments.startDate, {
								hour: 'numeric',
								minute: 'numeric',
							})}
							- ${formatDate(appointments.endDate, { hour: 'numeric', minute: 'numeric' })}`}
						</div>
					</Grid>
					<Grid item xs={7}>
						<Button
							startIcon={<CalendarTodayIcon />}
							className={classes.rescheduleButton}
							classes={{
								root: classes.rescheduleButtonIcon,
							}}
							onClick={handleRescheduleBtnClick}
						>
							Reschedule meeting
						</Button>
					</Grid>
					<Grid item xs={5}>
						<button
							className='tooltipJoinButton'
							onClick={handleVideoCall}
						>
							Join Video Call
						</button>
					</Grid>
				</Grid>
			</div>
		);
	};

	const handleVideoCall = (e) => {
		setLoading(true);
		var detailsForCall = {
			thisEmail: toolTipData?.email,
			thisName: toolTipData?.appName,
			thisAppointmentCode: toolTipData?.appCode,
			thisAppointmentTime: toolTipData?.appTime,
			thisUserType: toolTipData?.currentUserType,
			thisPhone: toolTipData?.phoneNumber,
			thisUID: toolTipData?.currentUserId,
			shortCode: toolTipData?.shortcode,
		};

		console.log('DETAILS FOR CALL ', detailsForCall);

		if (toolTipData !== undefined && notes !== undefined) {
			console.log('This is the note: ' + notes);
			var appointmentsRef = firebase
				.database()
				.ref(
					'/client_appointments/' +
						PROJECT_CODE.projectCode +
						'/' +
						toolTipData?.appCode +
						'/users/0'
				);

			appointmentsRef.update({
				notes: notes,
			});
		}

		history.push({
			pathname: '/videocall',
			state: {
				detail: detailsForCall,
			},
		});
		setLoading(false);
	};

	const handleCancel = () => {
		var deleteKey = toolTipData?.appCode;

		if (window.confirm('Do you really want to cancel an appointment?')) {
			var newDeleteRef = firebase
				.database()
				.ref('/client_appointments/' + PROJECT_CODE.projectCode)
				.child(deleteKey);

			let appointmentInfo;
			newDeleteRef.once('value', (snapshot) => {
				appointmentInfo = snapshot.val();
			});

			newDeleteRef.remove().then(() => {
				let users = appointmentInfo.users;
				if (users['0'] !== null && users['0'] !== undefined) {
					let userEmailDeletePush = firebase
						.database()
						.ref('/client_delete_emails')
						.child(PROJECT_CODE.projectCode)
						.push();
					let userEmailDeleteInfo = {
						adminUser: users['0'].email,
						email: users['0'].email,
						timeOfAppointment: appointmentInfo.timeOfAppointment,
					};
					userEmailDeletePush.set(userEmailDeleteInfo);
				}
				if (users['1'] !== null && users['1'] !== undefined) {
					let userEmailDeletePush = firebase
						.database()
						.ref('/client_delete_emails')
						.child(PROJECT_CODE.projectCode)
						.push();
					let userEmailDeleteInfo = {
						adminUser: users['1'].email,
						email: users['1'].email,
						timeOfAppointment: appointmentInfo.timeOfAppointment,
					};
					userEmailDeletePush.set(userEmailDeleteInfo);
				}
				if (users['2'] !== null && users['2'] !== undefined) {
					let userEmailDeletePush = firebase
						.database()
						.ref('/client_delete_emails')
						.child(PROJECT_CODE.projectCode)
						.push();
					let userEmailDeleteInfo = {
						adminUser: users['2'].email,
						email: users['2'].email,
						timeOfAppointment: appointmentInfo.timeOfAppointment,
					};
					userEmailDeletePush.set(userEmailDeleteInfo);
				}

				if (
					appointmentInfo.leadId &&
					appointmentInfo.leadToSalesAgent
				) {
					let leadId = appointmentInfo.leadId;
					let salesAgentId = appointmentInfo.leadToSalesAgent;
					let leadRef;
					let checkRef;
					let checkRef2;

					firebase
						.database()
						.ref(
							'/kavtek_leads/' +
								PROJECT_CODE.projectCode +
								'/' +
								leadId
						)
						.once('value', (snapshot) => {
							checkRef = snapshot.val();
						});

					firebase
						.database()
						.ref(
							'/kavtek_purchasers/' +
								PROJECT_CODE.projectCode +
								'/' +
								salesAgentId +
								'/' +
								leadId
						)
						.once('value', (snapshot) => {
							checkRef2 = snapshot.val();
						});
					if (checkRef) {
						leadRef = firebase
							.database()
							.ref(
								'/kavtek_leads/' +
									PROJECT_CODE.projectCode +
									'/' +
									leadId
							);
						leadRef.update({
							sentEmail: false,
						});
					} else if (checkRef2) {
						leadRef = firebase
							.database()
							.ref(
								'/kavtek_purchasers/' +
									PROJECT_CODE.projectCode +
									'/' +
									salesAgentId +
									'/' +
									leadId
							);
						leadRef.update({
							sentEmail: false,
						});
					}
				}
			});
			setTooltipVisible(false);
		}
	};

	const handleClose = () => {
		setTooltipVisible(false);
	};

	const handleCloseTooltip = () => {
		console.log('apCode: ', toolTipData?.appCode);
		if (toolTipData !== undefined && notes !== undefined) {
			var appointmentsRef = firebase
				.database()
				.ref(
					'/client_appointments/' +
						PROJECT_CODE.projectCode +
						'/' +
						toolTipData?.appCode +
						'/users/0'
				);

			console.log('handleCloseToolTip: ', toolTipData?.appCode);

			appointmentsRef.update({
				notes: notes,
			});
		}
		setToolTipData();
	};

	const handleCloseDateMenu = () => {
		setAnchorEl(null);
	};

	const handleOpenDateMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClickDateMenu = (event) => {
		setFilterByDate(event.target.innerText.trim());
		setCurrentViewName(event.target.innerText.trim());
		handleCloseDateMenu();
	};

	return (
		<>
			<RescheduleMeeting
				rescheduleModal={rescheduleModal}
				appointmentId={toolTipData?.appCode}
				handleRescheduleModalClose={handleRescheduleModalClose}
				appointmentTime={toolTipData?.appTime}
				setLoading={setLoading}
			/>
			<ScheduleMeeting
				showModal={modal.scheduleMeeting}
				scheduleModal={scheduleModal}
				handleScheduleModalClose={handleScheduleModalClose}
				dateClicked={dateClicked}
				setLoading={setLoading}
			/>
			<div className='calendarPage' id='calendarPage'>
				{loading && <CircularProgress className='circular-load' />}
				<Grid container spacing={2} style={{ marginBottom: '2em' }}>
					<Grid item container xs={12}>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								flex: '1',
							}}
						>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									marginBottom: '15px',
									alignItems: 'center',
								}}
							>
								<h2 id='calendar-title'>Agenda</h2>
								<div>
									<Button
										variant='outlined'
										endIcon={<ArrowDropDownIcon />}
										className='filterByDate'
										onClick={handleOpenDateMenu}
									>
										{filterByDate}
									</Button>
									<Menu
										anchorEl={anchorEl}
										onClose={handleCloseDateMenu}
										open={Boolean(anchorEl)}
									>
										<MenuItem onClick={handleClickDateMenu}>
											Day
										</MenuItem>
										<MenuItem onClick={handleClickDateMenu}>
											Week
										</MenuItem>
										<MenuItem onClick={handleClickDateMenu}>
											Month
										</MenuItem>
									</Menu>
								</div>
							</div>
							<Divider />
						</div>
					</Grid>
					<Grid item container md={12} lg={9} spacing={2}>
						<Grid item xs={12}>
							<Paper className='calendarContainer'>
								<Scheduler
									data={schedulerData}
									className='calender-comp'
								>
									<ViewState
										defaultCurrentDate={currentDate}
										currentViewName={currentViewName}
									/>
									<MonthView
										timeTableCellComponent={
											MonthViewTimeTableCell
										}
									/>
									<DayView
										startDayHour={7}
										endDayHour={20.5}
										timeTableCellComponent={
											DayViewTimeTableCell
										}
									/>
									<WeekView
										startDayHour={7}
										endDayHour={20.5}
										timeTableCellComponent={
											WeekViewTimeTableCell
										}
									/>

									<Appointments
										appointmentComponent={Appointment}
									/>

									<Toolbar />

									<TodayButton />
									<DateNavigator />
									<AppointmentTooltip
										contentComponent={TooltipContent}
										headerComponent={TooltipHeader}
										visible={tooltipVisible}
										appointmentMeta={appointmentMeta}
										onAppointmentMetaChange={
											onAppointmentMetaChange
										}
										onVisibilityChange={() => {
											setTooltipVisible(false);
										}}
									/>
									<AppointmentForm readOnly />
								</Scheduler>
							</Paper>
						</Grid>
					</Grid>
					<Grid item xs={12} sm={6} lg={3} spacing={2}>
						<Grid item xs={12}>
							<JoinShortCode />
						</Grid>
						<Grid item xs={12}>
							<UpcomingAppointmentList />
						</Grid>
					</Grid>
				</Grid>
			</div>
			{/* <div className='calendarPage'>
				<h2 id='calendar-title'>Agenda</h2>

				<div className='short-code'>
					<JoinShortCode />
				</div>

				<div className='main-cards'>
					<AddPeople />
					<AppointmentsList />
				</div>

				<div className='flex-calendar'>
					<Paper className='calendarContainer'>
						<Scheduler
							data={schedulerData}
							className='calender-comp'
						>
							<ViewState
								defaultCurrentDate={currentDate}
								currentViewName={currentViewName}
							/>
							<MonthView />
							<DayView startDayHour={7} endDayHour={20} />
							<WeekView startDayHour={7} endDayHour={20} />

							<Appointments appointmentComponent={Appointment} />

							<Toolbar />

							<ExternalViewSwitcher
								currentViewName={currentViewName}
								onChange={(e) => currentViewNameChange(e)}
							/>
							<TodayButton />
							<DateNavigator />
							<AppointmentTooltip showCloseButton />
							<AppointmentForm readOnly />
						</Scheduler>
					</Paper>

					{toolTipData && (
						<div className='appointment-detail'>
							{console.log(
								'THis is the tooldtuip data: ' +
									JSON.stringify(toolTipData)
							)}
							<Paper className={styles.tooltipPaper}>
								<div onClick={handleCloseTooltip}>
									<CloseIcon
										className={styles.tooltipCloseBtn}
									/>
								</div>
								<h2 className='tooltip-title'>
									Meeting Details
								</h2>
								<div className='tooltip-field'>
									<Person className={styles.tooltipIcon} />
									<p className='tooltip-label'>
										{toolTipData?.fullName}
									</p>
								</div>
								<div className='tooltip-field'>
									<DraftsIcon
										className={styles.tooltipIcon}
									/>
									<p className='tooltip-label'>
										{toolTipData?.email}
									</p>
								</div>
								<div className='tooltip-field'>
									<PhoneIcon className={styles.tooltipIcon} />
									<p className='tooltip-label'>
										{toolTipData?.phoneNumber}
									</p>
								</div>
								<div className='tooltip-notes-field'>
									<TextField
										placeholder='Notes'
										name='notes'
										value={notes}
										onChange={(e) => onChange(e)}
										className={styles.notesTextField}
										InputProps={{
											classes: {
												input: styles.notesInput,
											},
										}}
									/>
								</div>
								<div className='tooltip-actions'>
									<button
										className='tooltip-join'
										onClick={handleVideoCall}
									>
										Join
									</button>
									<button
										className='tooltip-cancel'
										onClick={handleCancel}
									>
										Cancel
									</button>
								</div>
							</Paper>
						</div>
					)}
				</div>
			</div> */}
		</>
	);
};

const mapStateToProps = (state) => ({
	userType: state.signIn.userType,
	modal: state.modals,
});

export default connect(mapStateToProps, {
	upcommingAppointments,
	openModal,
	closeModal,
})(Agenda);
